export var KioskTransactionType;
(function (KioskTransactionType) {
    KioskTransactionType[KioskTransactionType["Coin"] = 0] = "Coin";
    KioskTransactionType[KioskTransactionType["Leapa"] = 1] = "Leapa";
})(KioskTransactionType || (KioskTransactionType = {}));
